import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import Container = Phaser.GameObjects.Container;
import {ArtifactBasePanel} from "@/scenes.ui/artifact-base-panel";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import {UnlockInfo} from "@/store/artifact/types";
import CU from "@/utils/c-u";

export class SlotUnlockPanel extends ArtifactBasePanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, ui: UnlockInfo,
                slotX: number, slotY: number, unlockCallback: () => unknown, container: Container) {
        super(scene, canvas, slotX, slotY, container);
        this.setScale(1 / CU.S, 1 / CU.S);

        const title = TextUtils.addTextByFamily(this.scene, Tr('slot'), 0, -282, '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        let unlockLabel = TextUtils.addTextAdvanced(scene, Tr('etot.slot.mozhno.razblokirovat'), 0, -140,
            '#716f6a', 12, 'normal', 250, 'center', 2, Fonts.ARIAL_MT);

        let mainText = TextUtils.addTextByFamily(scene, Tr('razblokirovat.slot'),
            0, -20, '#ffd465', 18, 'normal', 240, Fonts.MYRIADPRO_BOLD);

        let okButton = new SquareButton(this.scene, 0, 160, 0,
            Keys.UI_ART_GREEN_BUTTON, undefined, Keys.IC_100_MITHRIL, Tr('razblokirovat'), false);

        this.add(okButton);

        let speedupPriceText = TextUtils.addText(scene, String(ui.price), 0, 196, '#ffffff', 25, 'bold', 200);

        okButton.setCallback(() => {
            if (this.isOnTop()) {
                unlockCallback();
            }
        });

        this.add([title, unlockLabel, mainText, speedupPriceText]);
    }
}
